import React, { useContext, useEffect, useReducer, useState } from 'react'
import { Context } from '../../Context/Context'
import { isUserVerifiedApi } from '../../Constants';
import ProfileDetailsView from './ProfileDetailsView';
import ProfessionalAccountUpdatesModal from 'Modals/ProfessionalAccountUpdatesModal';
import SeeUpdatesMadeOnAccount from './SeeUpdatesMadeOnAccount';
import { Link, useNavigate } from 'react-router-dom';
import useIsMobile from 'Hooks/useIsMobile';
import FirmCasePrefCard from './FirmCasePrefCard';

function LawFirmProfilePage({setShowEdit, setActivePanel}) {
  const [showUpdateDetails, setShowUpdateDetails] = useState(false);
  const [reRenderData, setReRenderData] = useState(false);
 const {makeApiCallFunc, setUserVerificationId} = useContext(Context);
 const {userDetails} = useContext(Context);
 const isMobile = useIsMobile();
 const navigate = useNavigate();
 const {profilePic} = userDetails;
 const attorneyProfilePic = userDetails?.attorney?.profilePic;
 const [isUserVerified, setIsUserVerified] = useState();

 const [isUserEditing, setIsUserEditing] = useState();
 const [responseReceived, setResponseReceived] = useState(false);
  const [updatesSent, setUpdatesSent] = useState(null);

    useEffect(() => {
      
            makeApiCallFunc(
              isUserVerifiedApi,
              {verified: userDetails?.verified},
              ({data}) => {
                console.log(data);
                console.log("userDetails in professional details", userDetails);
                setResponseReceived(true);
                setIsUserVerified(data.verified);
                setUpdatesSent(data?.approvalList);
              },
              (data) => {
                setResponseReceived(true);
                console.log(data)
              }
            )
          ;

      },[reRenderData])
    

      
    const data = {
        "Full name" : userDetails?.firstName+" "+userDetails?.lastName,
        "Email address"  : userDetails?.email,
        "Firm Name" : userDetails?.company? userDetails?.company : "--",
        "Website link" : userDetails?.lawFirmLink ? userDetails.lawFirmLink :  "--",
        "Phone number" : userDetails?.phoneNumber ? userDetails?.phoneNumber : "--",
       
    }
    const showEditOrPopup = () => {
      if(isUserVerified === 2 || isUserVerified === 3)
      {
          setIsUserEditing(true);
      }
      else
      {
        setShowEdit(true);
      }
    }
    const getButtonName = () => {
     switch(isUserVerified)
     {
      case 0:
        return "Complete profile";
      case 1:
      case 2:
      case 3:
        return "Edit Profile";
      case 4:
      case 5:
        return "Resubmit for review";
      default:
        return "Edit Profile";
     } 
    }
     const inReview = (isUserVerified !== 0 && isUserVerified !== 1) && updatesSent;
     return (
      <>
      {
        isUserEditing &&
        <ProfessionalAccountUpdatesModal
        uploadNew = {isUserEditing}
        onClose = {() => setIsUserEditing(false)}
        onSubmit = {() => {setShowEdit(true)}}
        />
      }
      <ProfileDetailsView
        title={userDetails?.company ? userDetails.company : (userDetails?.firstName+" "+userDetails?.lastName)}
        isUserVerified={isUserVerified}
        updatesSent={updatesSent}
        buttonName={responseReceived ? getButtonName() : null}
        onEdit={showEditOrPopup}
        updates={inReview &&
          <SeeUpdatesMadeOnAccount
          labels = {{
                  "First name" : "firstName",
                  "Last name" : "lastName",
                  "Email" : "email",
                  "Law firm Name" : "company",
                  "phone number" : "phoneNumber",
                  "Law firm website link" : "lawFirmLink",
                  "No. of years in business" : "experience",
                  "Case Preference" : "casePref",
                  "State Preference" : "statePref",
                 }}
          updatesSent={updatesSent}
          setReRenderData={setReRenderData}
          isDenied={(isUserVerified === 4 || isUserVerified === 5) ? true : false}
          showEditOrPopup={showEditOrPopup}
          variant="cards"
          />}
        sections={[
          { title: (isUserVerified !== 0 && isUserVerified !== 1) ? "Account details" : "Profile details", note: (isUserVerified !== 0 && isUserVerified !== 1) ? "Not affected by the review above." : null, data },
        ]}
      >
        <FirmCasePrefCard />
      </ProfileDetailsView>
    </>
  )
}

export default LawFirmProfilePage
